<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue';
  import { getMenuItems } from "@/components/layouts/utils";
  import { useLayoutStore } from "@/store/app";
  import { SIDEBAR_SIZE } from "@/app/const";
  import { useRoute, useRouter } from "vue-router";
  import { MenuItemType } from "../../types";
  import axios from '@/app/http/axios';


  const state = useLayoutStore();
  const route = useRoute();
  const router = useRouter();
  const menuItems = ref<MenuItemType[]>([])
  const path = computed(() => route.path);

  const isCompactSideBar = computed(() => {
    return state.sideBarSize === SIDEBAR_SIZE.COMPACT;
  });
  onMounted(async () => {
      menuItems.value = await getMenuItems()
  })

  const onClick = (path: string, isSingleLevel?: boolean) => {
    if (isSingleLevel) {
      const openListEle = document.querySelector(".v-list-group--open");
      if (openListEle) {
        const titleEle = document.querySelector(
          ".v-list-group--open .v-list-item--active"
        );
        if (titleEle) {
          const listItemsEle: any = document.querySelector(
            ".v-list-group--open .v-list-group__items"
          );
          if (listItemsEle) {
            const appendIcon = document.querySelector(
              ".v-list-group--open .v-list-item--active .v-list-item__append .ph-caret-up"
            );

            if (appendIcon) {
              appendIcon.classList.remove("ph-caret-up");
              appendIcon.classList.add("ph-caret-down");
              listItemsEle.style.display = "none";
              titleEle.classList.remove("v-list-item--active");
              openListEle.classList.remove("v-list-group--open");
            }
          }
        }
      }
    }
    // console.log('path>>>>>> ' + path);
    // router.push(path);
  };
</script>
<template>
  <v-container fluid class="py-0 px-3">
    <v-list class="navbar-nav h-100 vertical-menu-component pt-0" id="navbar-nav" open-strategy="single">
      <v-list-group v-for="(menuItem, index) in menuItems" :key="`${menuItem.label}-${index}`"
        :class="menuItem.isHeader ? 'menu-title' : 'nav-item'">
        <template #activator="{ props }">
          <!-- Header -->
          <v-list-item v-if="menuItem.isHeader" :data-key="`t-${menuItem.label}`" prepend-icon="" class="px-2"
            variant="text" append-icon="" rounded>
            <template #title>
              <div class="menu-title">
                {{ $t(`t-${menuItem.label}`) }}
              </div>
            </template>
          </v-list-item>
          <!-- Single Level Menu -->
          <v-list-item v-if="
            !(menuItem.subMenus && menuItem.subMenus.length) && menuItem.link
          " :data-key="`t-${menuItem.label}`" append-icon="" class="py-0 ps-5" :value="menuItem.link"
            :active="menuItem.link === path" :to="menuItem.link" height="45" min-height="45" rounded
            @click.prevent="menuItem.link && onClick(menuItem.link, true)">
            <template #title>
              <router-link :to="menuItem.link">
                <div class="nav-link menu-link" :class="isCompactSideBar ? 'pa-2' : 'd-flex align-center'">
                  <i :class="menuItem.icon" class="ph-lg" />
                  <div>{{ $t(`t-${menuItem.label}`) }}</div>
                </div>
              </router-link>
            </template>
          </v-list-item>
          <!-- Menu with sub-items -->
          <v-list-item v-if="menuItem.subMenus && menuItem.subMenus.length" :data-key="`t-${menuItem.label}`"
            v-bind="props" class="py-0 nav-link ps-5 menu-header-title" height="45" min-height="45" rounded>
            <template #title>
              <span class="nav-link menu-link" :class="isCompactSideBar ? 'pa-2' : 'd-flex align-center'">
                <i :class="menuItem.icon" class="ph-lg"></i>
                <span>{{ $t(`t-${menuItem.label}`) }}</span>
              </span>
            </template>
            <template #append="{ isActive }">
              <i v-if="!isCompactSideBar" :class="isActive ? 'ph ph-caret-up' : 'ph ph-caret-down'" class="ms-2"></i>
            </template>
          </v-list-item>
        </template>
        <v-list-group v-for="(subMenu, index) in menuItem.subMenus" :key="`submenu-${subMenu.label}-${index}`"
          :value="subMenu.link" :active="subMenu.link === path" :to="subMenu.link">
          <template #activator="{ props }">
            <!-- Sub Menu -->
            <v-list-item class="py-0 nav nav-sm nav-link sub-menu-list-item" density="compact" v-bind="props"
              :value="subMenu.link" :active="subMenu.link === path" :to="subMenu.link" height="38" min-height="38"
              rounded @click.prevent="subMenu.link && onClick(subMenu.link)">
              <template #title>
                <!-- <span class="nav-link menu-link py-0">
                  {{ $t(`t-${subMenu.label}`) }}
                </span> -->
                <router-link v-if="subMenu.link" :to="{ path: subMenu.link }">
                  <span class="nav-link menu-link py-0">
                    {{ $t(`t-${subMenu.label}`) }}
                  </span>
                </router-link>
              </template>
              <template #append="{ isActive }">
                <i v-if="!isCompactSideBar && subMenu.subMenu?.length"
                  :class="isActive ? 'ph ph-caret-up' : 'ph ph-caret-down'"></i>
              </template>
            </v-list-item>
          </template>
          <!-- Sub Menu of Sub Menu -->
          <v-list-item v-for="(nestedItem, index) in subMenu.subMenu" :key="index"
            class="py-0 nav nav-sm rail-navigation-list" density="compact" :to="nestedItem.link" height="38"
            min-height="38" rounded>
            <template #title>
              <router-link v-if="nestedItem.link" :to="{ path: nestedItem.link }">
                <span class="nav-link menu-link py-0">
                  {{ $t(`t-${nestedItem.label}`) }}
                </span>
              </router-link>
              <span v-else class="nav-link menu-link py-0">
                {{ $t(`t-${nestedItem.label}`) }}
              </span>
            </template>
          </v-list-item>
        </v-list-group>
      </v-list-group>
    </v-list>
  </v-container>
</template>
<style>
  .rotate90 {
    transform: rotate(90deg);
  }
</style>